<section class="movie-site_landing">
  <div class="movie-site_landing_media_wrapper">
    <ng-container *ngTemplateOutlet="media" />
  </div>
  <div class="movie-site_landing_menu_wrapper"></div>
</section>

<div class="movie-site_landing_overlap_wrapper">
  <div class="movie-site_landing_overlap_extra-content container-bounds">
    <div class="movie-site_landing_logo_wrapper">
      @if (!config().hideLogo) {
        <movie-site-logo-image [image]="config().logo" [movie]="movie()" class="movie-site_landing_logo pointer" />
      }
      @if (config().releaseMessage?.attachedToLogo) {
        <ng-container *ngTemplateOutlet="releseMessage" />
      }
    </div>
  </div>
  @if (!config().releaseMessage?.attachedToLogo) {
    <ng-container *ngTemplateOutlet="releseMessage; context: { $implicit: 'container-bounds' }" />
  }
  <movie-site-landing-menu [navActions]="navActions()" [fixedColor]="true" class="container-bounds" />
</div>

<ng-template #media>
  @if (config().display === 'video') {
    <ush-video
      #videomedia
      class="movie-site_landing_video media"
      [style.aspectRatio]="aspectRatio"
      [url]="videoBgUrl"
      [mute]="true"
      [autoplay]="true"
      [loop]="true"
      [disableTracking]="true"
    />
  } @else {
    <img
      class="movie-site_landing_image media"
      [ngSrc]="movie()!.tilePhotoUrl!"
      fill
      priority
      [alt]="movie()!.title + ' tile image'"
    />
  }
</ng-template>

<ng-template #releseMessage let-class>
  @if (!config().hideReleaseMessage && movie().releaseMessage) {
    <div class="movie-site_landing_release-message_wrapper" [ngClass]="class || ''">
      <p class="movie-site_landing_release-message pointer">
        {{ movie().releaseMessage || 'release Message' }}
      </p>
    </div>
  }
</ng-template>
